export const PATH = {
  petList: (category: string) => `${category}/list`,
  petDetail: (category: string, id: string) => `${category}/detail/${id}`,
} as const;
